import React, {useEffect, useState} from 'react';
import styles from './PlatformVersions.module.scss'
import {$t} from "../../../helpers/translator";
import api from "../../../helpers/api";
import Modal from "../../../components/miscellaneous/Modal/Modal";
import PlatformVersionAdd from "../../../components/Admin/PlatformVersionAdd/PlatformVersionAdd";
import DataTable from "../../../components/miscellaneous/DataTable/DataTable";
import _ from "lodash";
import Tooltip from "../../../components/miscellaneous/Tooltip/Tooltip";
import {FiInfo} from "react-icons/fi";

const AdminPlatformVersions = () => {
    const [showAddVersionModal, setShowAddVersionModal] = useState(false);
    const [newVersions, setNewVersions] = useState(null);

    const [versionHistoryPayload, setVersionHistoryPayload] = useState({
        sort: 'created_at',
        order: 'desc',
        page: 1,
        per_page: 15,
    })
    const [versionHistoryData, setVersionHistoryData] = useState(null)
    const [versionHistoryPagination, setVersionHistoryPagination] = useState(null)
    const [versionHistoryTableLoading, setVersionHistoryTableLoading] = useState(false)
    const [versionHistorySorted, setVersionHistorySorted] = useState({
        id: 'created_at',
        desc: true
    })

    const platformNames = {
        1: 'Soprano Titanium'
    }

    const countryGroupsNames = {
        1: 'Other [1]',
        2: 'Japan [2]'
    }

    useEffect(() => {
        (async function () {
            // setAddVersionData()

            await getNewVersions();
            await getVersionHistory();
        })();
    }, [versionHistoryPayload]);

    // use

    async function getVersionHistory() {
        try {
            setVersionHistoryTableLoading(true)
            let payload = versionHistoryPayload;
            let res = await api.get(`platform/versions?sort=${payload.sort}&order=${payload.order}&page=${payload.page}&per_page=${payload.per_page}`);
            // console.log('getVersions', res)
            if (res && res.success) {
                let data = res.data.data.data;
                _.forEach(data, (v, k) => {
                    v.machine_type = platformNames[v.machine_type];
                    v.country_group = countryGroupsNames[v.country_group];
                })
                setVersionHistoryData(res.data.data.data)
                setVersionHistoryPagination(res.data.data.pagination)

            }

            setVersionHistoryTableLoading(false)
        } catch (e) {
            console.error(e);
            setVersionHistoryTableLoading(false)
        }
    }

    async function getNewVersions() {
        try {
            let res = await api.get(`platform/new-versions`);
            // console.log('getNewVersions', res.data.data)
            if (res && res.success) {
                setNewVersions(res.data.data)
            }

        } catch (e) {
            console.error(e);
        }
    }

    function renderNewVersions() {
        return (
            <div>
                {newVersions ?
                    <>
                        {
                            Object.keys(newVersions).map((platform, platformCode) => {
                                return (
                                    <div key={platformCode} className={styles.versionPlatformContainer}>
                                        <div
                                            className={styles.versionPlatformName}>{platformNames[platform] ? platformNames[platform] : `Unknown platform (${platform})`}</div>
                                        <div>
                                            {
                                                Object.keys(newVersions[platform]).map((countryCodeVersions, countryK) => {
                                                    return (
                                                        <div key={countryK} className={styles.versionCountryContainer}>
                                                            <div
                                                                className={styles.versionCountryGroup}>{countryGroupsNames[countryCodeVersions] ? countryGroupsNames[countryCodeVersions] : `Unknown country group (${countryCodeVersions})`}</div>
                                                            <div>
                                                                {newVersions[platform][countryCodeVersions].map((version, i) => {
                                                                    return (
                                                                        <div key={i}>
                                                                            {version.equipment} : <span
                                                                            className={styles.versionNumber}>{version.version}</span>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                )
                            })}
                    </>
                    :
                    null
                }
            </div>
        )
    }

    function dataTableActionHandler(data) {

        if (data.key === 'page') {
            let payload = {...versionHistoryPayload};
            payload.page = data.value;

            setVersionHistoryPayload(payload);
        } else if (data.key === 'header') {
            let payload = {...versionHistoryPayload};

            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            payload.sort = data.value;

            setVersionHistoryPayload(payload);
            setVersionHistorySorted({
                id: data.value,
                desc: payload.order
            })
        }
    }

    function renderVersionHistoryTable() {
        let versionHistoryHeaders = [
            {
                name: $t('global.machines.versions.addedAt'),
                id: 'created_at',
                clickable: true
            },
            {
                name: $t('global.machines.versions.platform'),
                id: 'machine_type',
                clickable: true
            },
            {
                name: $t('global.machines.versions.module'),
                id: 'equipment',
                clickable: true
            },
            {
                name: $t('global.machines.versions.countryGroup'),
                id: 'country_group',
                clickable: true
            },
            {
                name: $t('global.machines.versions.version'),
                id: 'version',
                clickable: true
            },
            {
                name: $t('global.machines.versions.addedBy'),
                id: 'added_by_name',
                clickable: true
            },
        ]


        return (
            <div>
                <DataTable data={versionHistoryData}
                           headers={versionHistoryHeaders}
                           pagination={versionHistoryPagination}
                           loading={versionHistoryTableLoading}
                           sorted={versionHistorySorted}
                    // apiUrl={ this.getAPIUrl() }
                           onAction={(e) => dataTableActionHandler(e)}
                />
            </div>
        )
    }

    return (
        <div className={'container'}>
            <div className={'alma-box'}>
                <div className={'alma-box-header'}>
                    <div><h3>{$t('global.machines.versions.currentVersions')}</h3></div>
                    <div className={'alma-button'}
                         onClick={() => setShowAddVersionModal(true)}>{$t('global.machines.versions.addVersion')}</div>
                </div>
                <div className={`${'alma-box-content'}`}>
                    {renderNewVersions()}
                </div>
            </div>

            <div className={'alma-box'}>
                <div className={'alma-box-header'}>
                    <div><h3>{$t('global.machines.versions.versionsHistoryTable')}</h3></div>
                    <Tooltip content={$t('global.machines.versions.versionsHistoryTableExplained')}>
                        <FiInfo/>
                    </Tooltip>
                </div>
                <div className={`${'alma-box-content'}`}>
                    {renderVersionHistoryTable()}
                </div>
            </div>

            <Modal content={<PlatformVersionAdd onNewVersionAdded={async () => {
                setShowAddVersionModal(false);
                await getNewVersions();
                await getVersionHistory();
            }}/>}
                   onClose={() => setShowAddVersionModal(false)}
                   visible={showAddVersionModal}/>
        </div>
    )
}

export default AdminPlatformVersions;
